import welcomeData from '../../data/welcome.json';

export const WELCOME_MESSAGES = [
  "Hi there! What kind of support would be most helpful right now?",
  "Welcome back! How can I help you today?",
  "Good to see you! What would you like to work on?",
  "I'm here when you're ready. What can I help with?"
];

/**
 * Quick-action options derived from assistants/therapist/welcome.json
 * so they stay in sync automatically when options are added/removed.
 */
export const WELCOME_OPTIONS = (welcomeData.main_options || []).map(
  (opt: { label: string }) => ({ label: opt.label, value: opt.label })
);

export const ENCOURAGEMENT_MESSAGES = [
  "Great work! Keep the momentum going!",
  "You're doing amazing! One step closer to finishing!",
  "Excellent progress! You've got this!",
  "Nice job! Your dedication shows!",
  "Fantastic! You're making great headway!",
  "Well done! Keep up the excellent work!",
  "Outstanding! You're on a roll!",
  "Brilliant! Your clients are lucky to have you!",
  "Superb! Almost there!",
  "Wonderful! You're crushing it!"
];

export const getRandomEncouragementMessage = () => {
  return ENCOURAGEMENT_MESSAGES[Math.floor(Math.random() * ENCOURAGEMENT_MESSAGES.length)];
};
